import React, { useRef, useState, useEffect, useCallback, useMemo } from 'react';
import { Card, Stack } from '@mui/material';
import { usePageView } from 'src/hooks/use-page-view';
import { useSelection } from 'src/hooks/use-selection';
import ListSearch from 'src/components/ui/search/list-search';
import { ListTable } from './list-table';
import { ListView } from './list-view';
import { useTranslation } from 'react-i18next';
import { appStr } from 'src/locales/app_strings';
import { useRouter } from 'src/hooks/use-router';
import { nextNavigate } from 'src/utils/navigation-utils';
import { paths } from 'src/paths';
import TitleButton from 'src/components/ui/headers/title-button';
import DropdownPlates from 'src/components/dropdown/dropdown-plates';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import useForms from 'src/api/tms/vm-form';
import CloseIcon from 'src/icons/untitled-ui/free/x-close';
import DialogConfirm from './confirm-dialog';
import { tmsApi } from 'src/api/tms/vm-view';
import PageSection from 'src/layouts/page-section';

const Page = ({ dataSearch, dataStore, dataIds }) => {
  const { t } = useTranslation();
  const rootRef = useRef(null);
  const router = useRouter();
  const dataSelection = useSelection(dataIds);
  
  usePageView();

  const labels = useMemo(
    () => ({
      both: { short: 'plate', full: t(appStr.txt_040) },
    }),
    [t]
  );

  const hasFetched = useRef(false);
  const [tmsId, setTmsId] = useState(0);
  const fetchData = useCallback(async () => {
    if (hasFetched.current) return;
    hasFetched.current = true;

    tmsApi.getMyStatus(
      (result) => { setTmsId(result.id); }
    );
  }, []);
  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const [open, setOpen] = useState(false);
  // Function to open the dialog
  const handleOpenDialog = () => {
    setOpen(true);
  };
  // Function to close the dialog
  const handleCloseDialog = () => {
    setOpen(false);
  };

  const handleDetail = (item) => {
    nextNavigate(router, dataSearch.state, paths.tms.details, paths.tms.index, {
      id: item.id,
    });
  };

  // Common props object
  const commonProps = {
    dataStore: dataStore,
    onDeselectAll: dataSelection.handleDeselectAll,
    onDeselectOne: dataSelection.handleDeselectOne,
    onPageChange: dataSearch.handlePageChange,
    onRowsPerPageChange: dataSearch.handleRowsPerPageChange,
    onSelectAll: dataSelection.handleSelectAll,
    onSelectOne: dataSelection.handleSelectOne,
    page: dataSearch.state.page,
    rowsPerPage: dataSearch.state.rowsPerPage,
    selected: dataSelection.selected,
    onItemClicked: dataSearch.handleNavigateChange,
  };

  const { setCheckIn, setCheckOut } = useForms();

  const formik = useFormik({
    initialValues: {
      plateField: null,
    },
    validationSchema: Yup.object({
      plateField: Yup.object().nullable().required('Vui lòng chọn biển số'),
    }),
    onSubmit: async (values, helpers) => {
      // Open dialog
      handleOpenDialog();
    },
  });

  return (
    <PageSection title="Tms" rootRef={rootRef}>
    {({ isMobile }) => (
      <Stack spacing={1}>
        <TitleButton
          onButtonClick={formik.handleSubmit}
          name={tmsId > 0 ? t(appStr.txt_056) : t(appStr.txt_055)}
          icon={tmsId > 0 ? CloseIcon : undefined}
          extraContent={
            <DropdownPlates formik={formik} disabled={tmsId > 0} sx={{width: 200}} />
          }
          sx={{
            width: 160,
            mr: 3,
            textAlight: 'right',
          }}
        />
        <Card>
          <ListSearch
            onFiltersChange={dataSearch.handleFiltersChange}
            filtersQuery={dataSearch.state.filters.query}
            placeholder={'both'}
            filterLabels={labels}
          />
          {isMobile ? (
            <ListView {...commonProps} onDetailClicked={handleDetail} />
          ) : (
            <ListTable {...commonProps} onDetailClicked={handleDetail} />
          )}
        </Card>
        <DialogConfirm
          isOpen={open}
          handleClose={handleCloseDialog}
          formik={formik}
          tmsId={tmsId}
          onCheckIn={setCheckIn}
          onCheckOut={setCheckOut}
          onCompleted={(val) => {
            router.replace(paths.tms.redirect);
            // setTimeout(() => {
            //   // Reload page (F5) after success
            //   router.replace(paths.tms.redirect);
            // }, 500);
          }}
        />
      </Stack>
    )}
    </PageSection>
  );
};

export default Page;
